import SimpleHomeBreadcrumb from '@Components/Shared/SimpleHomeBreadcrumb';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useSetRecoilState } from 'recoil';

const LegalNoticesAndAccessibilityView = (props) => {

    const setShowCookieConsent = useSetRecoilState(atoms.showCookieConsent);
    const usercentricsEnabled = sandhills.TradeSites.React.ComponentProps['useUserCentricsCMP'];

    const showCookieConsentModal = () => {
        if (usercentricsEnabled) {
            window.UC_UI?.showFirstLayer();
        } else {
            setShowCookieConsent(true);
        }
    }

    const listItems = (options) => {
        return (
            options.map(item => (
                <>
                    <li>
                        {item.LinkId === 'updatecookies' ?
                            <a className={'legal-link-item'} role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); showCookieConsentModal(); } }} onClick={() => showCookieConsentModal()}>{item.LinkText}</a>
                            :
                            <a className={'legal-link-item'} href={item.LinkURL} target={item.LinkTargetName}>{item.LinkText}</a>
                        }
                    </li>
                </>
            ))
        );
    };


    return (
        <div className='info-content-container'>
            <div className='info-content-header'>
                <SimpleHomeBreadcrumb homeRoute={props.BreadCrumbHomeRoute} displayText={props.BreadCrumbText} />
            </div>
            <div className='legal-notices-and-accessibility-container'>
                <h1 className='pagename'><strong>{props.PageTitle}</strong></h1>
                <ul>
                    {listItems(props.LegalNoticeLinks)}
                </ul>
            </div>
        </div>
    );
};

export default LegalNoticesAndAccessibilityView;
global.LegalNoticesAndAccessibilityView = LegalNoticesAndAccessibilityView;